import { styled } from '@mui/material/styles';
import { Tabs } from '@mui/material';

export const TitleRow = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(0.5),
}));

export const EnvChip = styled('span')(({ theme }) => ({
  fontSize: '0.85rem',
  opacity: 0.7,
  marginLeft: theme.spacing(2),
}));

export const ChecklistTabs = styled(Tabs)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

// Inherits the theme's caption variant. Plain `styled('div')` instead of
// `styled(Typography)` so the `component` prop survives the wrapper — the
// previous JSS form rendered Typography as a `<div>`, which we preserve.
export const Meta = styled('div')(({ theme }) => ({
  ...theme.typography.caption,
  marginBottom: theme.spacing(2),
  opacity: 0.7,
}));

// Section divider between BDirect sections. `ready` switches to the muted
// divider colour for sections whose repo rows are all `tagged`/`no_changes`
// — visually downplays sections that no longer need attention. Only set on
// sections that actually carry repo rows; non-repo / empty sections keep
// the orange default.
export const SectionDivider = styled('hr', {
  shouldForwardProp: prop => prop !== 'ready',
})<{ ready?: boolean }>(({ theme, ready }) => ({
  border: 'none',
  borderTop: ready
    ? `6px solid ${theme.palette.divider}`
    : '6px solid rgb(252, 167, 0)',
  margin: theme.spacing(6, 0),
}));
